module.exports = __webpack_public_path__ + "static/media/ww_nyar1.a8144617.gif";